"use client";

import { TriangleAlert } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { Alert, AlertDescription, AlertTitle } from "@/components/_ui/alert";
import { Button } from "@/components/_ui/button";

export function TemporaryAccountError({ onRetry }: { onRetry?: () => void }) {
  const router = useRouter();

  return (
    <main className="bg-muted flex min-h-dvh items-center justify-center p-4">
      <Alert className="bg-background max-w-lg shadow-sm">
        <TriangleAlert className="size-4" />
        <AlertTitle>Mailtech is temporarily unavailable</AlertTitle>
        <AlertDescription className="space-y-4 pt-2">
          <p>
            We could not verify your Mailtech account. Your sign-in session is
            still active, so you can retry without signing in again.
          </p>
          <div className="flex gap-2">
            <Button onClick={onRetry ?? (() => router.refresh())}>
              Try again
            </Button>
            <Button asChild variant="outline">
              <Link href="/sign-out">Sign out</Link>
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </main>
  );
}
